module.exports = __webpack_public_path__ + "1ffc06af746f72c939ef731357ad927a.fbx";